import React, { createContext, useContext, useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export const DEFAULT_COLORS = {
  primary: '#1f8e38',
  primaryDark: '#176b2a',
  bg: '#f8f9fa',
  textMain: '#111827',
  textSecondary: '#6b7280',
  price: '#16a34a',
};

export const SettingsContext = createContext({
  settings: null,
  loading: true,
  refreshSettings: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_BASE}/settings`);
      if (!response.ok) return;
      const data = await response.json();
      setSettings(data);
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
